import { Link } from "react-router-dom";
import { riskCategories } from "@/mocks/blacklist";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          eyebrow="风险速查"
          title="按风险类型，快速定位你要查的方向"
          desc="不同场景的坑不一样。选一个类型，直接看这个领域里被反馈最多的风险表现。"
        />
        <Link
          to="/blacklist"
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap font-label text-sm font-medium text-primary-700 transition-colors hover:text-primary-800 cursor-pointer"
        >
          查看完整避雷名单
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {riskCategories.map((category) => {
          const href = category.key === "all" ? "/blacklist" : `/blacklist?category=${category.key}`;
          return (
            <Link
              key={category.key}
              to={href}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/50 cursor-pointer"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-50 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${category.icon} text-xl`} />
              </span>
              <span className="mt-4 font-heading text-base font-bold text-foreground-950">{category.name}</span>
              <span className="mt-1.5 font-label text-xs leading-relaxed text-foreground-500">{category.desc}</span>
              <span className="mt-4 inline-flex items-center gap-1 font-label text-xs font-medium text-primary-700">
                进入查看
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}